import React from 'react';
import {MasterLayout} from 'components/layouts';
import {UserDashboard} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';
import {UserLayout} from 'components/layouts/user';

class Dashboard extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Dashboard;
  }

  render() {
    return (
      <MasterLayout isActive='dashboard'>
        <UserLayout active="the-news">
          <UserDashboard/>
        </UserLayout>
      </MasterLayout>
    );
  }
}

export default MemberZone(Dashboard);



// WEBPACK FOOTER //
// ./pages/users/Dashboard.jsx